import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_PREFERRED_LANGUAGE_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetPreferredLanguageResult } from '../types/getPreferredLanguage.types';

export const GET_PREFERRED_LANGUAGE_TAGS = 'getPreferredLanguage';

export const getPreferredLanguage = (builder: BuilderType) =>
  builder.query<GetPreferredLanguageResult, void>({
    providesTags: [GET_PREFERRED_LANGUAGE_TAGS],
    query: (data) => ({
      data,
      method: 'POST',
      url: GET_PREFERRED_LANGUAGE_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetPreferredLanguageResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
